import { render, staticRenderFns } from "./IntegrationShopifyEc.vue?vue&type=template&id=e10630d6&scoped=true&"
import script from "./IntegrationShopifyEc.vue?vue&type=script&lang=ts&"
export * from "./IntegrationShopifyEc.vue?vue&type=script&lang=ts&"
import style1 from "./IntegrationShopifyEc.vue?vue&type=style&index=1&id=e10630d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10630d6",
  null
  
)

export default component.exports